// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

import type { CanonicalNpc, CanonicalShop, CanonicalLocation, ShopListingRef } from "../schema/types";

export const CANONICAL_NPCS: CanonicalNpc[] = [
  {
    "id": "albert-jr",
    "name": "Albert Jr.",
    "role": "roaming_buyer",
    "type": "SPECIAL_NPC",
    "locationText": "Suburbs",
    "teachesHobby": null,
    "bio": "Wandering merchant who buys your items. Always on the move!",
    "entityType": "npc"
  },
  {
    "id": "andrew",
    "name": "Andrew",
    "role": "vehicle_merchant",
    "type": "SHOP_NPC",
    "locationText": "Suburbs",
    "teachesHobby": null,
    "bio": "Sells motorcycles (green, black, white, red, pink), sedans (pink, yellow, blue, black), and mountain bikes. Provides a free starter vehicle.",
    "entityType": "npc"
  },
  {
    "id": "annie",
    "name": "Annie",
    "role": "music_emote_shop",
    "type": "SHOP_NPC",
    "locationText": "Central Square",
    "teachesHobby": null,
    "bio": "Music and friendship speak to them! Their shop offers instruments, emojis, and animations. Tip: New deals every day—don’t miss out!",
    "entityType": "npc"
  },
  {
    "id": "atara",
    "name": "Atara",
    "role": "village_mayor",
    "type": "SPECIAL_NPC",
    "locationText": "Central Square",
    "teachesHobby": null,
    "bio": "Mayor of the city, guide to the main story, and great visionary.",
    "entityType": "npc"
  },
  {
    "id": "azure",
    "name": "Azure",
    "role": "winter_event_vendor",
    "type": "EVENT_NPC",
    "locationText": "Onsen Mountain",
    "teachesHobby": null,
    "bio": "Sells event tokens by selling specific items",
    "entityType": "npc"
  },
  {
    "id": "bailey-j",
    "name": "Bailey J",
    "role": "birdwatching_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Central Square",
    "teachesHobby": "birdwatching",
    "bio": "The local bird expert! She will support you with rewards for your observations. She also has a shop where you can buy binoculars and bird food.",
    "entityType": "npc"
  },
  {
    "id": "bill",
    "name": "Bill",
    "role": "sea_fishing_host",
    "type": "SPECIAL_NPC",
    "locationText": "Fishing Village Square",
    "teachesHobby": null,
    "bio": "Expert in sea fishing. The sea holds no secrets for him.",
    "entityType": "npc"
  },
  {
    "id": "blanc",
    "name": "Blanc",
    "role": "gardening_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Central Square",
    "teachesHobby": "gardening",
    "bio": "Teaches you gardening and sells starter equipment.",
    "entityType": "npc"
  },
  {
    "id": "bob",
    "name": "Bob",
    "role": "furniture_merchant",
    "type": "SHOP_NPC",
    "locationText": "Central Square",
    "teachesHobby": null,
    "bio": "Our grandfather has a great talent for building. Every Saturday at 6:00 a.m., he renews the furniture display, which will be available for a week. Talk to him if you want to get natural building materials for your land.",
    "entityType": "npc"
  },
  {
    "id": "cassie",
    "name": "Cassie",
    "role": "park_ranger",
    "type": "SPECIAL_NPC",
    "locationText": "Forest Jump Puzzle",
    "teachesHobby": null,
    "bio": "A mysterious character who roams the forest under the moonlight.",
    "entityType": "npc"
  },
  {
    "id": "collector",
    "name": "Collector",
    "role": "launch_shop_vendor",
    "type": "SHOP_NPC",
    "locationText": "Town",
    "teachesHobby": null,
    "entityType": "npc"
  },
  {
    "id": "doris",
    "name": "Doris",
    "role": "weather_merchant",
    "type": "SPECIAL_NPC",
    "locationText": "Varies by weather",
    "teachesHobby": null,
    "bio": "Unique NPC who appears only during special weather events (rain, snowfall, rainbow, meteor shower). Sells exclusive recipes like Roll Cake, rare ingredients, emotes, and meteorite furniture. Uses Star Fragments as currency for meteor items",
    "entityType": "npc"
  },
  {
    "id": "dorothee",
    "name": "Dorothee",
    "role": "fashion_muse",
    "type": "SHOP_NPC",
    "locationText": "Central Square",
    "teachesHobby": null,
    "bio": "A true style icon! You'll find the perfect pair of shoes in their store. The clothing selection is updated daily, so don't forget to stop by and check it out.",
    "entityType": "npc"
  },
  {
    "id": "eric",
    "name": "Eric",
    "role": "former_theme_park_manager",
    "type": "SPECIAL_NPC",
    "locationText": "Onsen",
    "teachesHobby": null,
    "bio": "Friendly resident, manages daily delegations to assist the community.",
    "entityType": "npc"
  },
  {
    "id": "ka-ching",
    "name": "Ka Ching",
    "role": "collectibles_merchant",
    "type": "SHOP_NPC",
    "locationText": "Residential Street",
    "teachesHobby": null,
    "bio": "Owner of the general store. If you need it, she has it!",
    "entityType": "npc"
  },
  {
    "id": "massimo",
    "name": "Massimo",
    "role": "cooking_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Central Square",
    "teachesHobby": "cooking",
    "bio": "Restaurant chef and culinary mentor. Passion in every dish.",
    "entityType": "npc"
  },
  {
    "id": "mrs-joan",
    "name": "Mrs. Joan",
    "role": "pet_care_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Pet Store",
    "teachesHobby": "cat_care",
    "bio": "Owner of the pet store. Lover of all animals.",
    "entityType": "npc"
  },
  {
    "id": "naniwa",
    "name": "Naniwa",
    "role": "bug_catching_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Deer Tower",
    "teachesHobby": "bug_catching",
    "bio": "The entomologist at Heartopia will show you how to create delicate bubbles to capture insects. In his shop, you'll find everything you need for this hobby, including terrariums.",
    "entityType": "npc"
  },
  {
    "id": "oak-oak",
    "name": "Oak-Oak",
    "role": "roaming_oak",
    "type": "SPECIAL_NPC",
    "locationText": "Spirit-Oak Pine Forest",
    "teachesHobby": null,
    "entityType": "npc"
  },
  {
    "id": "patti",
    "name": "Patti",
    "role": "artist_forest_ranger",
    "type": "SPECIAL_NPC",
    "locationText": "Deer Tower",
    "teachesHobby": null,
    "bio": "Expert guardian of the forests, knowledgeable about hidden trails, creatures, and changes in the environment.",
    "entityType": "npc"
  },
  {
    "id": "vanya",
    "name": "Vanya",
    "role": "fishing_mentor",
    "type": "HOBBY_MENTOR",
    "locationText": "Residential Street",
    "teachesHobby": "fishing",
    "bio": "Fishing mentor. Find peace by the river.",
    "entityType": "npc"
  },
  {
    "id": "vernie",
    "name": "Vernie",
    "role": "flower_fields_caretaker",
    "type": "EVENT_NPC",
    "locationText": "Flower Fields",
    "teachesHobby": null,
    "entityType": "npc"
  },
  {
    "id": "will",
    "name": "Will",
    "role": "lighthouse_keeper",
    "type": "SPECIAL_NPC",
    "locationText": "Fishing Village",
    "teachesHobby": null,
    "entityType": "npc"
  }
];

export const CANONICAL_SHOPS: CanonicalShop[] = [
  {
    "id": "shop-andrew",
    "name": "Andrew's Shop",
    "npcId": "andrew",
    "locationId": "central-square",
    "entityType": "shop"
  },
  {
    "id": "shop-annie",
    "name": "Annie's Shop",
    "npcId": "annie",
    "locationId": "central-square",
    "entityType": "shop"
  },
  {
    "id": "shop-bailey-j",
    "name": "Bailey J's Shop",
    "npcId": "bailey-j",
    "locationId": "central-square",
    "stockModel": "service_exchange",
    "stockNotes": [
      "External service/stock observations include Camouflage Bush, Bird Food, Auto Bird Whistle, and Info Card Recycling.",
      "Bird Food price/value 0 should be treated as possible service/reward semantics."
    ],
    "provenanceStatus": "research-supported",
    "entityType": "shop"
  },
  {
    "id": "shop-blanc",
    "name": "Blanc's Shop",
    "npcId": "blanc",
    "locationId": "garden-street",
    "entityType": "shop"
  },
  {
    "id": "shop-bob",
    "name": "Bob's Shop",
    "npcId": "bob",
    "locationId": "central-square",
    "stockModel": "weekly_rotating",
    "stockNotes": [
      "Heartodex/Fandom/Heartopia.live support weekly Saturday 06:00 rotation for one week.",
      "Some shop guides mention daily-changing inventory at lower confidence."
    ],
    "provenanceStatus": "research-supported",
    "entityType": "shop"
  },
  {
    "id": "shop-collector",
    "name": "Collector's Shop",
    "npcId": "collector",
    "locationId": "central-square",
    "stockModel": "event_limited",
    "stockNotes": [
      "Historical 1CBT Celebration Sale data exists for Nov 4-Nov 18, 2025.",
      "Current zero listing count may represent dormant state, not absence of historical stock."
    ],
    "provenanceStatus": "research-supported",
    "entityType": "shop"
  },
  {
    "id": "shop-doris",
    "name": "Doris's Fortune Shop",
    "npcId": "doris",
    "locationId": "art-street",
    "stockModel": "weather_gated",
    "stockNotes": [
      "Local sugar list is partial.",
      "Weather variants add Roll Cake Recipe, postcards, umbrella, Rainbow Emote, meteor furniture, and Star Fragment exchanges.",
      "Plain Sugar as a Doris listing is uncertain."
    ],
    "provenanceStatus": "research-supported",
    "entityType": "shop"
  },
  {
    "id": "shop-dorothee",
    "name": "Dorothee's Shop",
    "npcId": "dorothee",
    "locationId": "central-square",
    "stockModel": "daily_rotating",
    "stockNotes": [
      "Clothing selection/inventory rotates daily.",
      "Do not create a complete static item table until a reliable item-price dump exists.",
      "Hair salon, clothing change, custom closets, and outfit presets are appearance services related to the store."
    ],
    "provenanceStatus": "research-supported",
    "entityType": "shop"
  },
  {
    "id": "shop-ka-ching",
    "name": "Ka Ching's Shop",
    "npcId": "ka-ching",
    "locationId": "central-square",
    "entityType": "shop"
  },
  {
    "id": "shop-massimo",
    "name": "Massimo's Shop",
    "npcId": "massimo",
    "locationId": "art-street",
    "entityType": "shop"
  },
  {
    "id": "shop-mrs-joan",
    "name": "Mrs. Joan's Shop",
    "npcId": "mrs-joan",
    "locationId": "central-square",
    "entityType": "shop"
  },
  {
    "id": "shop-naniwa",
    "name": "Naniwa's Shop",
    "npcId": "naniwa",
    "locationId": "central-square",
    "entityType": "shop"
  },
  {
    "id": "shop-vanya",
    "name": "Vanya's Shop",
    "npcId": "vanya",
    "locationId": "central-square",
    "entityType": "shop"
  }
];

export const CANONICAL_LOCATIONS: CanonicalLocation[] = [
  {
    "id": "art-street",
    "name": "Art Street",
    "region": "Town",
    "description": "Artistic street area",
    "entityType": "location"
  },
  {
    "id": "central-square",
    "name": "Central Square",
    "region": "Town",
    "description": "Main town area with shops and NPCs",
    "entityType": "location"
  },
  {
    "id": "crater-lake",
    "name": "Crater Lake",
    "region": "Nature",
    "description": "Lake in a crater",
    "entityType": "location"
  },
  {
    "id": "deer-tower",
    "name": "Deer Tower",
    "region": "Adventure",
    "description": "Tower area with deer",
    "entityType": "location"
  },
  {
    "id": "east-pier-fishing-village",
    "name": "East Pier Fishing Village",
    "region": "Coast",
    "description": "Pier/harbor area in the fishing village.",
    "entityType": "location"
  },
  {
    "id": "east-sea",
    "name": "East Sea",
    "region": "Sea",
    "description": "Sea area: East Sea.",
    "entityType": "location"
  },
  {
    "id": "fishing_village",
    "name": "Fishing Village",
    "region": "Fishing Village",
    "description": "Coastal area with fishing spots and Vanya",
    "entityType": "location"
  },
  {
    "id": "fishing-village-square",
    "name": "Fishing Village Square",
    "region": "Fishing Village",
    "description": "Main village square area.",
    "entityType": "location"
  },
  {
    "id": "forest-island",
    "name": "Forest Island",
    "region": "Forest",
    "description": "Island in the forest",
    "entityType": "location"
  },
  {
    "id": "forest-lake",
    "name": "Forest Lake",
    "region": "Forest",
    "description": "Lake surrounded by forest",
    "entityType": "location"
  },
  {
    "id": "garden-street",
    "name": "Garden Street",
    "region": "Town",
    "description": "Beautiful garden street in town",
    "entityType": "location"
  },
  {
    "id": "giant-wood-river",
    "name": "Giant Wood River",
    "region": "Nature",
    "description": "River with giant wood structures",
    "entityType": "location"
  },
  {
    "id": "home-plots",
    "name": "Home Plots",
    "region": "Town",
    "description": "Player housing and farm plots.",
    "entityType": "location"
  },
  {
    "id": "hot-spring-mountain",
    "name": "Hot Spring Mountain",
    "region": "Mountain",
    "description": "Mountain area: Hot Spring Mountain.",
    "entityType": "location"
  },
  {
    "id": "jump-puzzle",
    "name": "Jump Puzzle",
    "region": "Adventure",
    "description": "Area with jumping challenges",
    "entityType": "location"
  },
  {
    "id": "lighthouse",
    "name": "Lighthouse",
    "region": "Coast",
    "description": "Coastal lighthouse area",
    "entityType": "location"
  },
  {
    "id": "meadow-lake",
    "name": "Meadow Lake",
    "region": "Nature",
    "description": "Peaceful lake surrounded by meadows",
    "entityType": "location"
  },
  {
    "id": "old-sea",
    "name": "Old Sea",
    "region": "Sea",
    "description": "Sea area: Old Sea.",
    "entityType": "location"
  },
  {
    "id": "onsen-mountain",
    "name": "Onsen Mountain",
    "region": "Mountain",
    "description": "Mountain area with onsen",
    "entityType": "location"
  },
  {
    "id": "onsen-mountain-lake",
    "name": "Onsen Mountain Lake",
    "region": "Mountain",
    "description": "Lake near onsen mountain",
    "entityType": "location"
  },
  {
    "id": "purple-light-beach",
    "name": "Purple Light Beach",
    "region": "Beach",
    "description": "Beach with purple glowing sands",
    "entityType": "location"
  },
  {
    "id": "residential-street",
    "name": "Residential Street",
    "region": "Town",
    "description": "Residential street area.",
    "entityType": "location"
  },
  {
    "id": "rosy-river",
    "name": "Rosy River",
    "region": "Nature",
    "description": "Beautiful river with pink waters",
    "entityType": "location"
  },
  {
    "id": "ruins",
    "name": "Ruins",
    "region": "Adventure",
    "description": "Ancient ruins in the wilderness",
    "entityType": "location"
  },
  {
    "id": "shallow-river",
    "name": "Shallow River",
    "region": "Nature",
    "description": "A shallow river good for wading and fishing.",
    "entityType": "location"
  },
  {
    "id": "spirit-oak-pine-forest",
    "name": "Spirit Oak Pine Forest",
    "region": "Forest",
    "description": "Mystical forest with ancient trees",
    "entityType": "location"
  },
  {
    "id": "stone-cliff",
    "name": "Stone Cliff",
    "region": "Adventure",
    "description": "Cliff area with stones",
    "entityType": "location"
  },
  {
    "id": "suburban-lake",
    "name": "Suburban Lake",
    "region": "Town",
    "description": "Lake in suburban area",
    "entityType": "location"
  },
  {
    "id": "suburban-lake-2",
    "name": "Suburban Lake 2",
    "region": "Town",
    "description": "Second suburban lake area.",
    "entityType": "location"
  },
  {
    "id": "suburbs",
    "name": "Suburbs",
    "region": "Town",
    "description": "Residential area near town",
    "entityType": "location"
  },
  {
    "id": "tranquil-river",
    "name": "Tranquil River",
    "region": "Nature",
    "description": "Peaceful river area",
    "entityType": "location"
  },
  {
    "id": "whale-mountain",
    "name": "Whale Mountain",
    "region": "Mountain",
    "description": "Mountain area: Whale Mountain.",
    "entityType": "location"
  },
  {
    "id": "whale-sea",
    "name": "Whale Sea",
    "region": "Sea",
    "description": "Sea area: Whale Sea.",
    "entityType": "location"
  },
  {
    "id": "wharf",
    "name": "Wharf",
    "region": "Coast",
    "description": "Coastal wharf area",
    "entityType": "location"
  },
  {
    "id": "windmill-flower-field",
    "name": "Windmill Flower Field",
    "region": "Nature",
    "description": "Field with windmills and flowers",
    "entityType": "location"
  },
  {
    "id": "zephyr-sea",
    "name": "Zephyr Sea",
    "region": "Sea",
    "description": "Sea area: Zephyr Sea.",
    "entityType": "location"
  }
];

export const CANONICAL_SHOP_LISTINGS: ShopListingRef[] = [
  {
    "id": "shop-andrew-listing-0",
    "shopId": "shop-andrew",
    "itemId": "black-motorcycle",
    "price": 80000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-1",
    "shopId": "shop-andrew",
    "itemId": "black-sedan",
    "price": 600000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-2",
    "shopId": "shop-andrew",
    "itemId": "blue-sedan",
    "price": 600000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-3",
    "shopId": "shop-andrew",
    "itemId": "green-motorcycle",
    "price": 0,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-4",
    "shopId": "shop-andrew",
    "itemId": "pink-motorcycle",
    "price": 80000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-5",
    "shopId": "shop-andrew",
    "itemId": "pink-sedan",
    "price": 300,
    "currency": "WISHING_STARS"
  },
  {
    "id": "shop-andrew-listing-6",
    "shopId": "shop-andrew",
    "itemId": "red-motorcycle",
    "price": 80000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-7",
    "shopId": "shop-andrew",
    "itemId": "simplistic-mountain-bike",
    "price": 48,
    "currency": "WISHING_STARS"
  },
  {
    "id": "shop-andrew-listing-8",
    "shopId": "shop-andrew",
    "itemId": "white-convertible",
    "price": 750,
    "currency": "WISHING_STARS"
  },
  {
    "id": "shop-andrew-listing-9",
    "shopId": "shop-andrew",
    "itemId": "white-motorcycle",
    "price": 80000,
    "currency": "GOLD"
  },
  {
    "id": "shop-andrew-listing-10",
    "shopId": "shop-andrew",
    "itemId": "yellow-sedan",
    "price": 300,
    "currency": "WISHING_STARS"
  },
  {
    "id": "shop-blanc-listing-0",
    "shopId": "shop-blanc",
    "itemId": "anthurium-seeds",
    "price": 60,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-1",
    "shopId": "shop-blanc",
    "itemId": "calla-lily-seeds",
    "price": 90,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-2",
    "shopId": "shop-blanc",
    "itemId": "carnation-seeds",
    "price": 120,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-3",
    "shopId": "shop-blanc",
    "itemId": "corn-poppy-seeds",
    "price": 60,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-4",
    "shopId": "shop-blanc",
    "itemId": "cranesbill-seeds",
    "price": 300,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-5",
    "shopId": "shop-blanc",
    "itemId": "daisy-seeds",
    "price": 30,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-6",
    "shopId": "shop-blanc",
    "itemId": "hyacinth-seeds",
    "price": 300,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-7",
    "shopId": "shop-blanc",
    "itemId": "laceleaf-seeds",
    "price": 60,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-8",
    "shopId": "shop-blanc",
    "itemId": "lily-seeds",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-9",
    "shopId": "shop-blanc",
    "itemId": "morning-glory-seeds",
    "price": 90,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-10",
    "shopId": "shop-blanc",
    "itemId": "moth-orchid-seeds",
    "price": 300,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-11",
    "shopId": "shop-blanc",
    "itemId": "pansy-seeds",
    "price": 30,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-12",
    "shopId": "shop-blanc",
    "itemId": "romaine-lettuce-seed",
    "price": 10,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-13",
    "shopId": "shop-blanc",
    "itemId": "rose-seeds",
    "price": 300,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-14",
    "shopId": "shop-blanc",
    "itemId": "tulip-seeds",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-15",
    "shopId": "shop-blanc",
    "itemId": "avocado-seed",
    "price": 180,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-16",
    "shopId": "shop-blanc",
    "itemId": "cacao-seed",
    "price": 110,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-17",
    "shopId": "shop-blanc",
    "itemId": "carrot-seed",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-18",
    "shopId": "shop-blanc",
    "itemId": "corn-seed",
    "price": 170,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-19",
    "shopId": "shop-blanc",
    "itemId": "eggplant-seed",
    "price": 135,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-20",
    "shopId": "shop-blanc",
    "itemId": "fertilizer",
    "price": 160,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-21",
    "shopId": "shop-blanc",
    "itemId": "grape-seed",
    "price": 160,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-22",
    "shopId": "shop-blanc",
    "itemId": "growth-booster",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-23",
    "shopId": "shop-blanc",
    "itemId": "lettuce-seed",
    "price": 145,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-24",
    "shopId": "shop-blanc",
    "itemId": "pineapple-seed",
    "price": 15,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-25",
    "shopId": "shop-blanc",
    "itemId": "potato-seed",
    "price": 30,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-26",
    "shopId": "shop-blanc",
    "itemId": "strawberry-seed",
    "price": 125,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-27",
    "shopId": "shop-blanc",
    "itemId": "tomato-seed",
    "price": 10,
    "currency": "GOLD"
  },
  {
    "id": "shop-blanc-listing-28",
    "shopId": "shop-blanc",
    "itemId": "wheat-seed",
    "price": 95,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-0",
    "shopId": "shop-doris",
    "itemId": "blue-sugar",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-1",
    "shopId": "shop-doris",
    "itemId": "green-sugar",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-2",
    "shopId": "shop-doris",
    "itemId": "indigo-sugar",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-3",
    "shopId": "shop-doris",
    "itemId": "orange-sugar",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-4",
    "shopId": "shop-doris",
    "itemId": "red-sugar",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-5",
    "shopId": "shop-doris",
    "itemId": "sugar",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-6",
    "shopId": "shop-doris",
    "itemId": "violet-sugar",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-doris-listing-7",
    "shopId": "shop-doris",
    "itemId": "yellow-sugar",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-0",
    "shopId": "shop-massimo",
    "itemId": "butter",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-1",
    "shopId": "shop-massimo",
    "itemId": "cheese",
    "price": 100,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-2",
    "shopId": "shop-massimo",
    "itemId": "coffee-beans",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-3",
    "shopId": "shop-massimo",
    "itemId": "egg",
    "price": 100,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-4",
    "shopId": "shop-massimo",
    "itemId": "milk",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-5",
    "shopId": "shop-massimo",
    "itemId": "salsa-sauce",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-6",
    "shopId": "shop-massimo",
    "itemId": "springday-brown-sugar",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-7",
    "shopId": "shop-massimo",
    "itemId": "amazing-seasoning",
    "price": 3000,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-8",
    "shopId": "shop-massimo",
    "itemId": "cooking-oil",
    "price": 100,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-9",
    "shopId": "shop-massimo",
    "itemId": "frosted",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-10",
    "shopId": "shop-massimo",
    "itemId": "matcha-powder",
    "price": 250,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-11",
    "shopId": "shop-massimo",
    "itemId": "meat",
    "price": 200,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-12",
    "shopId": "shop-massimo",
    "itemId": "pasteurized-egg",
    "price": 100,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-13",
    "shopId": "shop-massimo",
    "itemId": "red-bean",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-14",
    "shopId": "shop-massimo",
    "itemId": "rice-flour",
    "price": 50,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-15",
    "shopId": "shop-massimo",
    "itemId": "tea-leaves",
    "price": 250,
    "currency": "GOLD"
  },
  {
    "id": "shop-massimo-listing-16",
    "shopId": "shop-massimo",
    "itemId": "universal-ingredient",
    "price": 2000,
    "currency": "GOLD"
  },
  {
    "id": "shop-mrs-joan-listing-0",
    "shopId": "shop-mrs-joan",
    "itemId": "cat-food",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-mrs-joan-listing-1",
    "shopId": "shop-mrs-joan",
    "itemId": "dog-food",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-mrs-joan-listing-2",
    "shopId": "shop-mrs-joan",
    "itemId": "universal-animal-food",
    "price": 150,
    "currency": "GOLD"
  },
  {
    "id": "shop-naniwa-listing-0",
    "shopId": "shop-naniwa",
    "itemId": "inflatable-insect-attractor",
    "price": 2000,
    "currency": "GOLD"
  },
  {
    "id": "shop-naniwa-listing-1",
    "shopId": "shop-naniwa",
    "itemId": "large-vivarium",
    "price": 200,
    "currency": "WISHING_STARS"
  },
  {
    "id": "shop-naniwa-listing-2",
    "shopId": "shop-naniwa",
    "itemId": "medium-vivarium",
    "price": 98000,
    "currency": "GOLD"
  },
  {
    "id": "shop-naniwa-listing-3",
    "shopId": "shop-naniwa",
    "itemId": "sense-booster",
    "price": 4000,
    "currency": "GOLD"
  },
  {
    "id": "shop-naniwa-listing-4",
    "shopId": "shop-naniwa",
    "itemId": "small-vivarium",
    "price": 34000,
    "currency": "GOLD"
  }
];
